module.exports = __webpack_public_path__ + "img/frasco_cili_500.a78a5575.png";